import { Fragment } from 'react';

const salesforceBase = 'https://sogelink.lightning.force.com/lightning/r';

export const salesforceRecordUrl = (type: 'Asset' | 'Contract' | 'Account', id: string, baseUrl?: string) =>
  `${baseUrl ? `${baseUrl}/lightning/r` : salesforceBase}/${type}/${encodeURIComponent(id)}/view`;

// Assets uses a configured Lightning component, not a standard related-list route.
export const salesforceContractAssetsUrl = (id: string, baseUrl: string) =>
  `${baseUrl}/lightning/cmp/force__dynamicRelatedListViewAll?${new URLSearchParams({
    force__flexipageId: 'Contract_LightningPage001',
    force__cmpId: 'lst_dynamicRelatedList3',
    force__recordId: id,
  })}`;

export const webkuaContractUrl = (companyNumber: string, contractNumber: string) =>
  `/customers/${encodeURIComponent(companyNumber)}/contracts/${encodeURIComponent(contractNumber)}`;

export const webkuaProductListUrl = (companyNumber: string) =>
  `/customers/${encodeURIComponent(companyNumber)}/product-list`;

export function ReconciliationLink({ href, label }: { href?: string | null; label: string }) {
  return href
    ? <a href={href} target="_blank" rel="noopener noreferrer" onClick={(event) => event.stopPropagation()}>{label}</a>
    : <>{label}</>;
}

export function ReconciliationLinks({ links }: { links: Array<{ label: string; href?: string | null }> }) {
  return <>{links.map((link, index) => (
    <Fragment key={`${index}-${link.label}`}>
      {index > 0 && ', '}
      <ReconciliationLink {...link} />
    </Fragment>
  ))}</>;
}
